var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"copyRef",attrs:{"data-clipboard-text":_vm.copytext}}),_c('span',{on:{"click":_vm.copy}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }